import React from 'react';
import Header from '../components/Header/header';
import news from '../images/covers/news.jpg';
import NewsPreviewFull from "../components/NewsPreviewFull/news-preview-full";

export default ({ data }) => {

  return (
    <div className="team">
      <Header
        image={news}
        title={"NANOTECH LAB | YUSHIN GROUP"}
        subtitle={"News"}
      />

      <div className={"container"}>
        <div className={"row"} style={{margin: "14px 0"}}>
        {
          data.allContentfulNews.edges.map(( { node } ) => {
            return <NewsPreviewFull key={node.id} title={node.title} image={node.image.file.url} description={node.description.description} link={'/news/' + node.slug}/>
          })
        }
        </div>
      </div>
      
    </div>
  );
};

export const query = graphql`
  query NewsQuery {
    allContentfulNews (sort: {fields: [createdAt], order:DESC}) {
      edges {
        node {
          id
          title
          slug
          createdAt
          description {
            id
            description
          }
          content {
            id
            content
          }
          image {
            id
            file {
              url
              fileName
              contentType
            }
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/news.js